import { useCallback } from 'react';
import { useNavigate, useNavigationType } from 'react-router-dom';

const useGoBack = () => {
  const navigate = useNavigate();
  const type = useNavigationType();
  const goBack = useCallback(
    (options) => {
      if (type === 'POP') {
        navigate('..', { replace: true, ...options });
        return;
      }
      navigate(-1, options);
    },
    [navigate, type],
  );

  return {
    goBack,
    navigate,
  };
};

export default useGoBack;
